import React, { Component } from "reactn";
import { DialogTitle, DialogActions, Button } from "@material-ui/core";
import styled from "styled-components";

import { BlueButton } from "js/react/components/UiComponents.js";
import DialogContent from "./DialogContent";
import BeautifulDialog from "./BeautifulDialog";

const DialogHeader = styled.div`
    display: flex;
    justify-content: center;
    padding: 30px 20px 0 20px;
`;

export default class MessageDialog extends Component {
    render() {
        const {
            title,
            message,
            header,
            buttonText,
            acceptOnClose,
            onClick,
            onClose,
            closeDialog,
            align,
            buttonOptions = {}
        } = this.props;

        return (
            <BeautifulDialog
                closeDialog={() => {
                    if (acceptOnClose) {
                        onClick && onClick();
                    }
                    closeDialog();
                }}
                onClose={onClose ? onClose : () => { }}
                align={align}
            >
                {header && <DialogHeader>{header}</DialogHeader>}
                <DialogTitle>{title}</DialogTitle>
                <DialogContent>{message}</DialogContent>
                <DialogActions>
                    {buttonOptions.color === "blue" ? (
                        <BlueButton
                            onClick={() => {
                                closeDialog();
                                onClick && onClick();
                            }}
                        >
                            {buttonText || "OK"}
                        </BlueButton>
                    ) : (
                        <Button
                            onClick={() => {
                                onClick && onClick();
                                closeDialog();
                            }}
                        >
                            {buttonText || "OK"}
                        </Button>
                    )}
                </DialogActions>
            </BeautifulDialog>
        );
    }
}
